/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Cart count badge update
  const updateCartBadges = () => {
    const badges = document.querySelectorAll('[data-cart-count-badge]');
    if (!badges.length) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        badges.forEach(badge => {
          badge.textContent = cart.item_count;
          badge.classList.toggle('hidden', cart.item_count === 0);
        });
      });
  };

  // Observe cart toggle class changes to sync badge count
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        updateCartBadges();
        break;
      }
    }
  });

  document.querySelectorAll('.cart__toggle').forEach(btn => {
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  });







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
